'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _ElementCreateButton = require('./ElementCreateButton');

var _ElementCreateButton2 = _interopRequireDefault(_ElementCreateButton);

var _PopupPanel = require('../../../components/popupPanel/PopupPanel');

var _PopupPanel2 = _interopRequireDefault(_PopupPanel);

var _elementActions = require('../../../element/elementActions');

var _popupActions = require('../../../components/popupPanel/popupActions');

var _elementRegistry = require('../../../../common/elements/elementRegistry');

var _cardConstants = require('../../../../common/cards/cardConstants');

var _linkConstants = require('../../../../common/links/linkConstants');

var _imageConstants = require('../../../../common/images/imageConstants');

require('./ElementCreatePopup.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        dispatchCreateElement: function dispatchCreateElement(_ref) {
            var elementType = _ref.elementType,
                location = _ref.location;
            return dispatch((0, _elementActions.createAndSelectElement)({ elementType: elementType, location: location }));
        },
        dispatchClosePopup: function dispatchClosePopup() {
            return dispatch((0, _popupActions.closePopup)());
        }
    };
};

var ElementCreatePopup = function ElementCreatePopup(props) {
    return _react2.default.createElement(
        _PopupPanel2.default,
        _extends({ popupId: 'element-create' }, props, { className: 'ElementCreatePopup', arrowDir: 'bottom' }),
        _react2.default.createElement(
            'ul',
            { className: 'button-list' },
            _react2.default.createElement(_ElementCreateButton2.default, _extends({}, props, {
                elementType: _cardConstants.CARD_TYPE,
                name: (0, _elementRegistry.getElementDisplayName)(_cardConstants.CARD_TYPE) })),
            _react2.default.createElement(_ElementCreateButton2.default, _extends({}, props, {
                elementType: _linkConstants.LINK_TYPE,
                name: (0, _elementRegistry.getElementDisplayName)(_linkConstants.LINK_TYPE) })),
            _react2.default.createElement(_ElementCreateButton2.default, _extends({}, props, {
                elementType: _imageConstants.IMAGE_TYPE,
                name: (0, _elementRegistry.getElementDisplayName)(_imageConstants.IMAGE_TYPE) }))
        )
    );
};

ElementCreatePopup.propTypes = {
    dispatchCreateElement: _propTypes2.default.func,
    dispatchClosePopup: _propTypes2.default.func,
    currentBoardId: _propTypes2.default.string
};

exports.default = (0, _reactRedux.connect)(null, mapDispatchToProps)(ElementCreatePopup);


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/mobile/elementCreate/ElementCreatePopup.js
// module id = 2213
// module chunks = 0